///<reference path="commonjs.d.ts"/>
require("./schemes/http");
require("./schemes/urn");
require("./schemes/mailto");



/*****************
 ** WEBPACK FOOTER
 ** ./~/uri-js/build/schemes.js
 ** module id = 867
 ** module chunks = 2
 **/